import React from 'react';
import WalletSelection from './WalletSelection';
import './App.css'; // Ensure your CSS reflects the styles from your HTML template
import USADA from './USADA.png';

function App() {
  const mintAsset = async () => {
    // Implement the minting logic here
    alert('Minting functionality to be implemented.');
  };

  return (
    <div className="app-container">
      <div className="banner">USADA</div>
      <div className="content">
        <img src={USADA} alt="USADA" width="350" height="300" />
        <div className="description">Click mint to purchase one USADA for 10₳</div>
        <WalletSelection />
      </div>
    </div>
  );
}

export default App;
